import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

interface OnboardingFlowContextProps {
  t: TFunction<'translation', undefined>;
  activeStep: number;
  onClickNextStep: () => void;
  onClickPreviousStep: () => void;
  onboardingData: OnboardingData;
  setOnboardingData: Dispatch<SetStateAction<OnboardingData>>;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
  companyIdNumber: number;
  setCompanyIdNumber: Dispatch<SetStateAction<number>>;
  languageId: number;
  setIsExistingManager: Dispatch<SetStateAction<boolean>>;
  isExistingManager: boolean;
}

export enum CompanyStepFieldNames {
  NAME = 'name',
  DIFFERENT_COMMERCIAL_NAME = 'differentCommercialName',
  COMMERCIAL_NAME = 'commercialName',
  COMPANY_ID_NUMBER = 'companyIdNumber',
  COMPANY_FORMAT = 'companyFormat',
}

interface OnboardingFlowCompanyStepFields {
  name: string;
  differentCommercialName: boolean;
  commercialName?: string;
  companyIdNumber: number;
  companyFormat: string;
}

export enum AddressStepFieldNames {
  STREET_NAME = 'streetName',
  HOUSE_NUMBER = 'houseNumber',
  POST_BOX = 'postBox',
  ZIP_CODE = 'zipCode',
  CITY = 'city',
  COUNTRY_ID = 'countryId',
}

interface OnboardingFlowAddressStepFields {
  streetName: string;
  houseNumber: string;
  postBox?: string;
  zipCode: string;
  city: string;
  countryId: number;
}

export enum ContactStepFieldNames {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
}

interface OnboardingFlowContactStepFields {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export enum AccountStepFieldNames {
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'confirmPassword',
}

interface OnboardingFlowAccountStepFields {
  languageId?: number;
  password: string;
  confirmPassword: string;
}

interface OnboardingData {
  company: OnboardingFlowCompanyStepFields;
  address: OnboardingFlowAddressStepFields;
  contact: OnboardingFlowContactStepFields;
  account: OnboardingFlowAccountStepFields;
}

export type {
  OnboardingFlowContextProps,
  OnboardingFlowCompanyStepFields,
  OnboardingFlowAddressStepFields,
  OnboardingFlowContactStepFields,
  OnboardingFlowAccountStepFields,
  OnboardingData,
};
